const _ = require('lodash');
const fillServerErrors = require('../../../common/components/servererrorfiller');

module.exports = function (resetPasswordService, $state, passwordValidationService, $sce) {
    return {
        restrict: 'E',
        scope: {
            passwordResetToken: '@'
        },
        link(scope) {
            let timeout;
            scope.pageLoading = true;
            scope.loading = false;
            scope.isTokenValid = false;
            scope.passwordReset = {
                password: '',
                confirmPassword: ''
            };

            scope.passwordPatternError = passwordValidationService.passwordPatternError;
            scope.passwordPattern = passwordValidationService.getPattern();
            scope.htmlTooltip = $sce.trustAsHtml(passwordValidationService.passwordHint);

            resetPasswordService.validatePasswordReminderToken(scope.passwordResetToken).then(function (response) {
                scope.pageLoading = false;
                scope.isTokenValid = response.Success;
            }).catch(function () {
                scope.pageLoading = false;
                scope.isTokenValid = false;
            });

            scope.submit = function () {
                scope.loading = true;
                resetPasswordService.resetPassword(scope.passwordReset.password, scope.passwordReset.confirmPassword, scope.passwordResetToken).then(function (response) {
                    scope.loading = false;
                    if (response.Success) {
                        $state.go('home').then(() => {
                            timeout = setTimeout(() => {
                                window.location.reload();
                            });
                        });
                    }
                }).catch(function (response) {
                    scope.loading = false;
                    scope.serverErrors = {};
                    _.forEach(response.data.ResponseStatus.Errors, function (n) {
                        if (n.FieldName === 'ReminderToken') {
                            scope.isTokenValid = false;
                        } else {
                            fillServerErrors.fillForm(scope.resetPasswordForm, response.data.ResponseStatus.Errors, scope);
                        }
                    });
                });
            };
            scope.$on('$destroy', function () {
                clearTimeout(timeout);
            });
        },
        template: require('./reset-password-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/resetpassword/reset-password-directive.js
 **/